import { NavbarService } from "./../../services/navbar-service.service";
import { AuthService } from "./../../services/auth.service";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormControl, Validators, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ISubscription } from "rxjs/Subscription";
import { MatSnackBar } from "@angular/material";
import { AuthMessage } from "../../extra/auth-message";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnDestroy {

  loading = false; // used to display progress spinner

  hide = true; // hide password input text

  emailControl = new FormControl("", [Validators.required, Validators.email]);

  form = new FormGroup({
    email: this.emailControl,
    password: new FormControl()
  });

  constructor(
    public auth: AuthService,
    private route: ActivatedRoute,
    public router: Router,
    public navbarService: NavbarService,
    public snackBar: MatSnackBar
  ) {
    navbarService.hide();
    auth.user$.subscribe(user => { // TODO unsubscribe onDestroy
      if (user) {
        this.router.navigate(["/"]);
      }
    });
  }

  onFormSubmit() {
    this.loading = true;
    const that = this;
    this.auth
      .loginWithEmailAndPassword(
        this.form.value.email,
        this.form.value.password
      ).catch((error) => {
        this.loading = false;
        this.snackBar.open(error, "Dismiss");
      });
  }

  loginWithFacebook() {
    const that = this;
    this.auth.loginWithFacebook();
  }

  loginWithGoogle() {
    const that = this;
    this.auth.loginWithGoogle();
  }

  loginWithTwitter() {
    const that = this;
    this.auth.loginWithTwitter();
  }

  openSnack(message: string, action?: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }

  getErrorMessage() {
    return this.emailControl.hasError("required")
      ? "You must enter a email"
      : this.emailControl.hasError("email") ? "Not a valid email" : "";
  }

  ngOnDestroy() {
    this.navbarService.show();
  }
}



// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/ui/login/login.component.ts